// Claude: rewritten to match SellerCatalog UI — no product tags 01-04-2026
import React, { useEffect, useState } from "react";
import { Box, Badge, Button, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import { MdArrowBack, MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/Actions";
import { Buyerscreens } from "../../Constants/data";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { errorHandler } from "../../Utils/handler";
import AddBuyerUrlModal from "../../Components/Modals/AddBuyerUrlModal";
import ConfirmationModal from "../../Components/Modals/ConfirmationModal";

type LinkItemProps = {
  id: string;
  title: string;
  url: string;
  assetType?: string;
  onEdit: () => void;
  onDelete: () => void;
};

const LinkItem: React.FC<LinkItemProps> = ({ id, title, assetType, onEdit, onDelete }) => (
  <Box width={"100%"} pt={3} pb={3} pl={2} pr={2} mb={2} border={"1px"} borderColor={"gray.200"}>
    <Flex justifyContent={"space-between"} alignItems={"flex-start"}>
      <Box flex={1} mr={2}>
        <Text fontSize={"sm"} fontWeight={500} color={"#0E122F"} wordBreak="break-word">{title}</Text>
        {assetType && (
          <Text fontSize={"10px"} fontWeight={500} px={2} py={"1px"} borderRadius={"full"}
            bg={"#E8F5E9"} color={"#2E7D32"} display={"inline-block"} mt={1}>
            {assetType}
          </Text>
        )}
      </Box>
      <Flex gap={1} flexShrink={0} alignItems="center">
        <Button size="xs" variant="ghost" color="#0E122F" _hover={{ bg: "gray.100" }} onClick={onEdit} aria-label="Edit">
          <MdOutlineEdit size={17} />
        </Button>
        <Button size="xs" variant="ghost" color="#C62828" _hover={{ bg: "red.50" }} onClick={onDelete} aria-label="Delete">
          <MdDeleteOutline size={17} />
        </Button>
      </Flex>
    </Flex>
  </Box>
);

const BuyerCatalog = () => {
  const buyerAsset = useSelector((state: any) => state.buyerAsset);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { success, error } = useToastWrapper();

  const [addUrl, setAddUrl] = useState(false);
  const [editAsset, setEditAsset] = useState<{ _id: string; assetTitle: string; assetUrl: string; assetType?: string } | null>(null);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [assetDeleteId, setAssetDeleteId] = useState<string>("");

  const handleOpenAddModal = () => { setEditAsset(null); setAddUrl(true); };
  const handleOpenEditModal = (asset: { _id: string; assetTitle: string; assetUrl: string; assetType?: string }) => {
    setEditAsset(asset);
    setAddUrl(true);
  };
  const handleCloseModal = () => {
    dispatch(actions.buyerAssets.resetForm({}));
    setEditAsset(null);
    setAddUrl(false);
  };

  const handleOpenDeleteConfirm = (id: string) => { setAssetDeleteId(id); setDeleteConfirm(true); };
  const handleCloseDeleteConfirm = () => { setAssetDeleteId(""); setDeleteConfirm(false); };

  const getAssets = async () => {
    try {
      const res = await BuyerAPI.getMyAssets();
      if (res) dispatch(actions.buyerAssets.setAssets({ links: res.data.data }));
    } catch (err) {
      error(errorHandler(err));
    }
  };

  const deleteAsset = async (assetId: string) => {
    try {
      await BuyerAPI.deleteBuyerAsset(assetId);
      getAssets();
      success("Asset deleted", "");
    } catch (err) {
      error(errorHandler(err));
    }
  };

  useEffect(() => {
    dispatch(actions.buyerMenu.set({ activeMenu: Buyerscreens.PROFILE }));
    getAssets();
  }, []);

  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"}
      bg={"linear-gradient(180deg, #EFF6FF 0%, #FFFFFF 100%)"} minH={"100dvh"} maxH={"100dvh"}>

      <Modal closeIcon={null} footer={null} title={null} open={addUrl}
        onOk={handleCloseModal} onCancel={handleCloseModal} destroyOnClose>
        <AddBuyerUrlModal handleCloseModal={handleCloseModal} editAsset={editAsset} />
      </Modal>

      <Modal closeIcon={null} footer={null} title={null} open={deleteConfirm}
        onOk={handleCloseDeleteConfirm} onCancel={handleCloseDeleteConfirm}>
        <ConfirmationModal
          handleCloseModal={handleCloseDeleteConfirm}
          handleSubmit={() => { deleteAsset(assetDeleteId); handleCloseDeleteConfirm(); }}
          title={"Delete Asset"}
          message={"Are you sure you want to delete this asset? This action cannot be undone."}
          confirmBtnText={"Yes, Delete"}
          rejectButtonText={"No"}
        />
      </Modal>

      <Flex w={"100%"} px={"30px"} py={5} bg={"#0E122F"} color={"white"}
        alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Digital Assets</Text>
        </Flex>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            buyer (beta)
          </Text>
        </VStack>
      </Flex>

      <Box w={"100%"} px={4} display={"flex"} justifyContent={"space-between"}
        alignItems={"center"} mt={3} mb={1}>
        <Text fontSize={"18px"} fontWeight={700}>Digital Assets</Text>
        <Button
          bg="#0E122F" color="white"
          px={3} py={1} h={"auto"} minH={"auto"}
          borderRadius={"full"} fontSize={"xs"} fontWeight={400}
          _hover={{ bg: "#2E7D32" }}
          onClick={handleOpenAddModal}
        >
          Add
        </Button>
      </Box>

      <Text fontSize={"12px"} color={"gray.500"} px={4} mb={3}>
        Add links to your company briefs, requirement specs, presentations, or any assets you'd like to share with sellers.
      </Text>

      <Box w={"100%"} px={4}>
        {typeof buyerAsset.links !== "string" && buyerAsset.links.length > 0 ? (
          buyerAsset.links.map((link: any) => (
            <LinkItem
              key={link._id}
              id={link._id}
              title={link.assetTitle}
              url={link.assetUrl}
              assetType={link.assetType}
              onEdit={() => handleOpenEditModal({ _id: link._id, assetTitle: link.assetTitle, assetUrl: link.assetUrl, assetType: link.assetType })}
              onDelete={() => handleOpenDeleteConfirm(link._id)}
            />
          ))
        ) : (
          <Text fontSize={"14px"} fontWeight={"light"}>No assets attached</Text>
        )}
      </Box>
    </Box>
  );
};

export default BuyerCatalog;
